import { useSelector } from 'react-redux';
import { selectConnectPrinters } from '../../store/shipstation-connect/ss-connect.selectors';
import { emptyArray } from 'ui-components/default-props/empty';

export const usePrinterGroups = () => {
  return useSelector(selectConnectPrinters) || emptyArray;
};
